var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.t(
            "text",
            "Enter your name so other users can see who is editing"
          ),
          expression:
            "t('text', 'Enter your name so other users can see who is editing')"
        }
      ],
      staticClass: "guest-name-dialog",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.setGuestName()
        }
      }
    },
    [
      _c(
        "label",
        [
          _c("Avatar", {
            attrs: { url: _vm.avatarUrl, "disable-tooltip": true, size: 32 }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.guestName,
            expression: "guestName"
          }
        ],
        attrs: { type: "text", "aria-label": _vm.t("text", "Edit guest name") },
        domProps: { value: _vm.guestName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.guestName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "icon-confirm",
        attrs: {
          type: "submit",
          "aria-label": _vm.t("text", "Save guest name")
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }